import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { createSelector } from './selectorWrapper'
import { pageSelectors } from './basicState'
import { isGen4TitleType } from '../utils/titleTypes'

export const isTVSelector = createSelector(
  pageSelectors.headerDetail,
  (detailFragment?: WpsRuntime.atv.wps.DetailFragmentModelProps) => Boolean(detailFragment && detailFragment.entityType == 'TV Show')
)

export const isGen4 = createSelector(
  pageSelectors.self,
  (self?: WpsRuntime.atv.wps.SelfFragmentModelProps) => Boolean(self && isGen4TitleType(self.titleType))
)
